// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"2c240504","256":"b588bf78","331":"af823444","472":"f6ad2e5b","541":"a0506647","799":"f67dba6b","842":"19606d03","955":"cddbe2d3"}[chunkId] + ".chunk.js";
};